<template>
	<div class="resultados">
		<div class="titulo-orden">
			<div class="orden order-1 order-lg-2">
				<p>Ordenar por:</p>
				<b-form-select v-model="orden">
					<b-form-select-option value="posicion-voto">Posición en el Voto</b-form-select-option>
					<b-form-select-option value="lista">Lista</b-form-select-option>
					<b-form-select-option value="nombre">Nombre</b-form-select-option>
					<b-form-select-option value="votos">Votos</b-form-select-option>
				</b-form-select>
			</div>
			<div class="order-2 order-lg-1">
				<h2>{{ votacion.title }}</h2>
			</div>
		</div>
		<div v-if="comunas" class="comunas">
			<span v-for="(comuna, index) in comunas" :key="index" class="comuna">{{ comuna | capitalize }}</span>
		</div>
		<b-nav tabs justified class="info-votos-totales">
			<b-nav-item v-for="(voto, index) in votacion.resumenVotos" :key="index"
				>{{ voto.glosa_cand }}: <strong>{{ voto.votos | formatNumber }}</strong></b-nav-item
			>
		</b-nav>
		<div class="resultados-votos">
			<transition-group>
				<template v-for="votos in sortedVotos">
					<h3 v-if="votos.type === 'nombre-pacto'" class="nombre-lista" :key="`nombre-pacto-${votos.cod}`">
						{{ votos.glosa }}
					</h3>
					<h4 v-else-if="votos.type === 'nombre-partido'" class="nombre-partido" :key="`nombre-partido-${votos.cod}`">
						{{ votos.glosa }}
					</h4>
					<div v-else class="candidato" :class="electos[votos.cod_cand]" :key="`candidato-${votos.cod_cand}`">
						<div class="informacion">
							<p class="nombre">{{ votos.glosa_cand }}</p>
							<p class="partido">
								<template v-if="votos.glosa_pacto === 'SIN NOMBRE'">{{ votos.glosa_part }}</template>
								<template v-else>{{ votos.glosa_pacto }} | {{ votos.glosa_part }}</template>
							</p>
						</div>
						<div class="votos">
							<div class="barra row">
								<div class="col-9 col-md-12 order-md-2 px-md-0">
									<b-progress :value="votos.votos" :max="votacion.resumenVotos[0].votos"></b-progress>
								</div>
								<div class="col-3 col-md-12 order-md-1 px-md-0 numero">
									<label class="d-none d-md-block">Resultado:</label
									><strong
										>{{
											!votos.votos ? 0 : percentage(votos.votos, votacion.resumenVotos[0].votos) | formatNumber
										}}%</strong
									>
								</div>
							</div>
							<label class="total-candidato"
								><strong>{{ votos.votos | formatNumber }}</strong> votos</label
							>
						</div>
					</div>
				</template>
			</transition-group>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		votacion: {
			type: Object,
			required: true
		},
		electos: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			orden: 'votos'
		}
	},
	computed: {
		comunas() {
			if (!this.votacion.comunas) {
				return null
			}

			return this.votacion.comunas.map(comuna => comuna.glosa_zona)
		},
		sortedVotos() {
			const votos = this.votacion.votos.slice()

			switch (this.orden) {
				case 'nombre':
					return votos.sort((a, b) => a.glosa_cand.localeCompare(b.glosa_cand))
				case 'votos':
					return votos.sort((a, b) => b.votos - a.votos)
				case 'lista': {
					votos.sort((a, b) => {
						const diffPacto = a.glosa_pacto.localeCompare(b.glosa_pacto)

						if (diffPacto !== 0) {
							return diffPacto
						}

						const diffPartido = a.glosa_part.localeCompare(b.glosa_part)

						return diffPartido !== 0 ? diffPartido : a.can_orden - b.can_orden
					})

					const arr = []
					let lastPacto = null
					let lastPartido = null

					votos.forEach(voto => {
						if (voto.glosa_pacto !== lastPacto && voto.glosa_pacto !== 'SIN NOMBRE') {
							lastPacto = voto.glosa_pacto
							lastPartido = null
							arr.push({
								type: 'nombre-pacto',
								cod: voto.cod_pacto,
								glosa: voto.glosa_pacto
							})
						}

						if (voto.glosa_part !== lastPartido) {
							lastPartido = voto.glosa_part
							arr.push({
								type: lastPacto ? 'nombre-partido' : 'nombre-pacto',
								cod: voto.cod_part,
								glosa: voto.glosa_part
							})
						}

						arr.push(voto)
					})

					return arr
				}
				default:
					return votos.sort((a, b) => a.can_orden - b.can_orden)
			}
		}
	},
	methods: {
		percentage(votos, total) {
			return (votos * 100) / total
		}
	}
}
</script>

<style scoped lang="scss">
.v-move {
	transition: transform 1s ease-in-out;
}

.v-enter-active {
	transition: all 0.3s ease;
}
.v-leave-active {
	transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.v-enter,
.v-leave-to {
	transform: translateX(10px);
	opacity: 0;
}

.resultados {
	padding-top: 12px;

	.titulo-orden {
		margin-bottom: 37px;
		h2 {
			color: #172a4c;
			font-family: Lato;
			font-size: 22px;
			font-weight: bold;
			letter-spacing: 0;
			line-height: 27px;
			position: relative;

			&::after {
				content: '';
				width: 60px;
				height: 2px;
				background-color: #368cf6;
				position: absolute;
				bottom: -15px;
				left: 0;
			}
		}
		.orden {
			select {
				height: 48px;
				color: #172a4c;
				font-family: Lato;
				font-size: 16px;
				letter-spacing: 0;
				line-height: 19px;
				margin-bottom: 30px;
			}
		}
	}

	.comunas {
		margin-bottom: 30px;

		.comuna {
			color: #5c6981;
			font-family: Lato;
			font-size: 14px;
			letter-spacing: 0;
			line-height: 20px;

			&:not(:last-child)::after {
				content: ' | ';
			}
		}
	}

	.info-votos-totales {
		margin-bottom: 30px;

		.nav-link {
			border: 1px solid #dbe0e4;
			border-radius: 0;
			color: #5c6981;
			font-family: Lato;
			font-size: 13px;
			letter-spacing: 0;
			line-height: 14px;
			padding: 7px 15px;
			display: flex;
			cursor: inherit;
		}

		strong {
			font-size: 15px;
			margin-left: auto;
		}

		.nav-item:last-child {
			background-color: #f0f2f5;
		}
	}

	.resultados-votos {
		color: #172a4c;
		font-family: Lato;
		margin-bottom: 30px;

		.nombre-lista {
			font-size: 18px;
			font-weight: bold;
			letter-spacing: 0;
			margin-top: 20px;
			line-height: 22px;
			margin-bottom: 10px;
			margin-top: 20px;
		}

		.nombre-partido {
			font-size: 16px;
			letter-spacing: 0;
			line-height: 19px;
			margin-bottom: 15px;
			margin-left: 21px;
		}
		.candidato {
			border: 1px solid rgba(136, 153, 166, 0.3);
			padding: 9px 16px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 8px;
			position: relative;

			.informacion {
				.nombre {
					font-size: 14px;
					font-weight: bold;
					letter-spacing: 0;
					line-height: 18px;
					margin-bottom: 8px;
				}
				.partido {
					color: #5c6981;
					font-size: 13px;
					letter-spacing: 0;
					line-height: 14px;
					margin: 0;
					white-space: nowrap;
					text-overflow: ellipsis;
					overflow: hidden;
				}
			}

			.votos {
				font-size: 15px;
				letter-spacing: 0;
				line-height: 18px;
				text-align: right;
				min-width: 255px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-top: 12px;
				.barra {
					width: 100%;
					margin-right: 58px;
					.numero {
						color: #5c6981;
						font-size: 11px;
						letter-spacing: 0;
						line-height: 11px;
						display: flex;

						label {
							margin-top: 3px;
						}

						strong {
							color: #0f6f5a;
							font-size: 15px;
							font-weight: bold;
							letter-spacing: 0;
							line-height: 18px;
							margin-left: auto;
						}
					}
					.progress {
						margin-top: 12px;
					}
				}
				.total-candidato {
					min-width: 100px;
				}
			}

			&.electo {
				background: linear-gradient(180deg, #155eb8 16px, #368cf6 0%);
				padding-top: 26px;
				border-bottom: 1px solid #dfe3e7;
				color: #ffffff;

				.partido,
				.votos .barra .numero,
				.votos .barra .numero strong {
					color: #ffffff;
				}
				.votos .barra ::v-deep .progress {
					background-color: #72aef8;

					.progress-bar {
						background-color: #155eb8;
					}
				}
			}

			&.electo::before {
				position: absolute;
				top: 3px;
				left: 0;
				right: 0;
				margin: auto;
				text-align: center;
				content: '\f00c    CANDIDATO ELECTO';
				color: #ffffff;
				font-family: Lato, 'Font Awesome 5 Pro';
				font-size: 9px;
				font-weight: bold;
				letter-spacing: 2px;
				line-height: 9px;
			}

			&.electo-barra {
				background: linear-gradient(180deg, #155eb8 16px, #ffffff 0%);
				padding-top: 26px;
				border-bottom: 1px solid #dfe3e7;
			}
			&.electo-barra::before {
				position: absolute;
				top: 3px;
				left: 0;
				right: 0;
				margin: auto;
				text-align: center;
				content: '\f00c    CANDIDATO ELECTO';
				color: #ffffff;
				font-family: Lato, 'Font Awesome 5 Pro';
				font-size: 9px;
				font-weight: bold;
				letter-spacing: 2px;
				line-height: 9px;
			}

			&.electo-right {
				background: linear-gradient(270deg, #368cf6 34px, #ffffff 0%);
				padding-right: 40px;
				border-left: 1px solid #dfe3e7;

				.votos {
					padding-right: 14px;
				}
			}
			&.electo-right::before {
				position: absolute;
				top: 50%;
				right: 9px;
				margin-top: -15px;
				content: '\f058';
				color: #ffffff;
				font-family: 'Font Awesome 5 Pro';
				font-size: 16px;
				font-weight: 900;
			}

			&.no-electo {
				opacity: 0.6;
			}

			&.potencialmente-electo {
				background: linear-gradient(180deg, #1bb594 16px, #d1f0ea 0%);
				padding-top: 26px;
				border-bottom: 1px solid #dfe3e7;
				color: #172a4c;

				.partido,
				.votos .barra .numero,
				.votos .barra .numero strong {
					color: #172a4c;
				}
				.votos .barra ::v-deep .progress {
					background-color: #f1faf8;

					.progress-bar {
						background-color: #1bb594;
					}
				}
			}

			&.potencialmente-electo::before {
				position: absolute;
				top: 3px;
				left: 0;
				right: 0;
				margin: auto;
				text-align: center;
				content: 'CANDIDATO POTENCIALMENTE ELECTO';
				color: #ffffff;
				font-family: Lato, 'Font Awesome 5 Pro';
				font-size: 9px;
				font-weight: bold;
				letter-spacing: 2px;
				line-height: 9px;
			}

			&.va-a-segunda-vuelta {
				background: linear-gradient(180deg, #f29a1d 16px, #fcebd2 0%);
				padding-top: 26px;
				border-bottom: 1px solid #dfe3e7;
				color: #172a4c;

				.partido,
				.votos .barra .numero,
				.votos .barra .numero strong {
					color: #172a4c;
				}
				.votos .barra ::v-deep .progress {
					background-color: #f1faf8;

					.progress-bar {
						background-color: #f29a1d;
					}
				}
			}

			&.va-a-segunda-vuelta::before {
				position: absolute;
				top: 3px;
				left: 0;
				right: 0;
				margin: auto;
				text-align: center;
				content: 'VA A SEGUNDA VUELTA';
				color: #ffffff;
				font-family: Lato, 'Font Awesome 5 Pro';
				font-size: 9px;
				font-weight: bold;
				letter-spacing: 2px;
				line-height: 9px;
			}
		}
	}
}
@media (max-width: 768px) {
	.resultados {
		.info-votos-totales {
			.nav-link {
				font-size: 14px;
				min-width: 190px;
			}

			strong {
				margin-top: 27px;
			}
		}

		.resultados-votos {
			.candidato {
				display: block;
			}
		}
	}
}

@media (min-width: 768px) {
	.resultados {
		.resultados-votos {
			.nombre-lista {
				margin-top: 35px;
			}

			.candidato {
				.informacion {
					padding-right: 25px;

					.partido {
						max-width: 352px;
					}
				}

				.votos {
					margin-top: 0;
					.barra {
						width: 130px;
						margin-right: 0;
						.numero {
							label {
							}

							strong {
							}
						}
						.progress {
						}
					}
				}

				&.electo {
					padding-top: 28px;
				}

				&.electo-barra {
					padding-top: 28px;
				}

				&.electo-right {
					background: linear-gradient(270deg, #368cf6 40px, #ffffff 0%);

					.votos {
						padding-right: 10px;

						.total-candidato {
							display: flex;
							flex-direction: column;
							padding-right: 13px;
							text-align: center;
							min-width: 0;
						}
					}
				}
				&.electo-right::before {
					right: 10px;
				}
			}
		}
	}
}

@media (min-width: 992px) {
	.resultados {
		padding-top: 22px;

		.titulo-orden {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 25px;

			h2 {
				font-size: 20px;
				line-height: 24px;

				&::after {
					bottom: -10px;
				}
			}
			.orden {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				width: 48%;

				p {
					color: #5c5c5c;
					font-family: Lato;
					font-size: 14px;
					letter-spacing: 0;
					line-height: 17px;
					width: 133px;
					margin: 0;
				}

				select {
					height: 38px;
					margin-bottom: 0;
				}
			}
		}
	}
}
@media (min-width: 1200px) {
	.resultados {
		.resultados-votos {
			.candidato {
				.informacion {
					.partido {
						max-width: 460px;
					}
				}
			}
		}
	}
}
</style>
